export interface BridgesSizing {
  cellSize: number;
  islandRadius: number;
  bridgeStroke: number;
  bridgeOffset: number;
  hitStrokeWidth: number;
  islandFontSize: number;
  islandTapExtra: number;
  boardPadding: number;
}

export function computeBridgesSizing(vw: number, vh: number, dpr: number): BridgesSizing {
  const safeVw = Math.max(0, vw);
  const safeDpr = Math.max(1, Math.min(3, dpr || 1));

  let cellSize: number;
  let islandRadius: number;
  let bridgeStroke: number;
  let bridgeOffset: number;
  let hitStrokeWidth: number;
  let islandFontSize: number;
  let islandTapExtra: number;

  if (safeVw <= 380) {
    cellSize = 44;
    islandRadius = 20;
    bridgeStroke = 7;
    bridgeOffset = 8;
    hitStrokeWidth = 40;
    islandFontSize = 17;
    islandTapExtra = 16;
  } else if (safeVw <= 480) {
    cellSize = 52;
    islandRadius = 20;
    bridgeStroke = 7;
    bridgeOffset = 8;
    hitStrokeWidth = 36;
    islandFontSize = 17;
    islandTapExtra = 14;
  } else if (safeVw <= 768) {
    cellSize = 56;
    islandRadius = 19;
    bridgeStroke = 7;
    bridgeOffset = 8;
    hitStrokeWidth = 32;
    islandFontSize = 16;
    islandTapExtra = 10;
  } else {
    cellSize = 60;
    islandRadius = 18;
    bridgeStroke = 6;
    bridgeOffset = 7;
    hitStrokeWidth = 28;
    islandFontSize = 16;
    islandTapExtra = 8;
  }

  if (safeDpr >= 2 && safeVw <= 768) {
    hitStrokeWidth = Math.max(hitStrokeWidth, 38);
  }

  const boardPadding = islandRadius + bridgeStroke + 4;

  // vh kept in signature for future breakpoint tuning (e.g. landscape phones).
  void vh;

  return {
    cellSize,
    islandRadius,
    bridgeStroke,
    bridgeOffset,
    hitStrokeWidth,
    islandFontSize,
    islandTapExtra,
    boardPadding,
  };
}
